<footer class="footer">
  <div class="footer-inner">
    <div class="footer-top">
      <div>
        <div class="footer-brand">Africa Tamilcharal</div>
        <div class="footer-tagline">"Where every page turns a new chapter"</div>
        <p class="footer-desc">{{ siteContentService.content().aboutText }}</p>
        <div class="footer-social" aria-label="Social links">
          <a href="#" aria-label="Facebook">f</a>
          <a href="#" aria-label="Instagram">ig</a>
          <a href="#" aria-label="Twitter">x</a>
          <a href="#" aria-label="YouTube">▶</a>
        </div>
      </div>
      <div class="footer-col">
        <h4>Explore</h4>
        <ul>
          <li><a routerLink="/books">Books</a></li>
          <li><a routerLink="/magazine">Magazine</a></li>
          <li><a routerLink="/authors">Authors</a></li>
          <li><a routerLink="/events">Events</a></li>
          <li><a routerLink="/books">Large Print Editions</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>Company</h4>
        <ul>
          <li><a routerLink="/about">About Us</a></li>
          <li><a routerLink="/about">Our Mission</a></li>
          <li><a routerLink="/press">Press</a></li>
          <li><a routerLink="/contact">Contact</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>Support</h4>
        <ul>
          <li><a routerLink="/faq">Help Center</a></li>
          <li><a routerLink="/shipping">Shipping &amp; Delivery</a></li>
          <li><a routerLink="/returns">Returns</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© 2026 Africa Tamilcharal. All rights reserved.</span>
      <span>Powered by Krishworks </span>
    </div>
  </div>
</footer>
